import * as React from 'react'
import { StackChildren, Text } from '@doordash/design-language'
import { Modal } from '@doordash/component-modal'
import Button from '@doordash/component-button'

import t from '../../strings'

export const NoBankAccountModal = ({ onClose }) => (
  <Modal
    onClose={onClose}
    title={t.noBankTitle()}
    size={Modal.Sizes.Small}
    actionsFillContainer={true}
    isFullScreenOnMobile={false}
  >
    <StackChildren>
      <Text>{t.noBankContent1()}</Text>
      <Text>{t.noBankContent2()}</Text>
      <Button onClick={() => onClose()}>{t.noBankButton()}</Button>
    </StackChildren>
  </Modal>
)
